import React, { useEffect, useState } from "react";
import { LASDataClassification, LASDataClassificationType } from "../../../common/LASDataClassification";
import { Card, Checkbox } from "antd";
import { ClassificationContainer } from "./Classification.style";
import { CheckboxChangeEvent } from 'antd/es/checkbox';

export default function Classification() {
    const [selectAll, setSelectAll] = useState(false);
    const [selectedItems, setSelectedItems] = useState<LASDataClassificationType[]>([]);

    // Add default classification to the classification list 
    // Because the default classification is not in the LASDataClassification list
    const classification: LASDataClassificationType[] = [
        ...LASDataClassification,
        {
            value: "DEFAULT",
            label: "Default"
        }
    ]
    const localStorageKey = 'classificationState';
    
    useEffect(() => {
        const storedState = localStorage.getItem(localStorageKey);
        if (storedState) {
            const { selectedItems: storedSelectedItems, selectAll: storedSelectAll } = JSON.parse(storedState);
            setSelectedItems(storedSelectedItems);
            setSelectAll(storedSelectAll);
        }else{
            setSelectedItems(classification.map(item => ({ value: item.value, label: item.label })));
            setSelectAll(true);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem(localStorageKey, JSON.stringify({ selectedItems, selectAll }));
    }, [selectedItems, selectAll]);

    const handleSelectAllChange = (e: CheckboxChangeEvent) => {
        const checked = e.target.checked;
        setSelectAll(checked);
        setSelectedItems(checked ? classification.map(item => ({ value: item.value, label: item.label })) : []);
    };

    const handleItemChange = (e: CheckboxChangeEvent, item: LASDataClassificationType) => {
        const checked = e.target.checked;
        setSelectedItems(prevItems => {
            const updatedItems = checked
                ? [...prevItems, item]
                : prevItems.filter(prevItem => prevItem.value !== item.value);
            setSelectAll(updatedItems.length === classification.length);
            return updatedItems;
        });
    };

    useEffect(() => {
        classification.forEach((item, index) => {
            if (window.potreeViewer.classifications.hasOwnProperty(item.value)) {
                let isVisible = selectedItems.some(selectedItem => selectedItem.value === item.value);
                window.potreeViewer.setClassificationVisibility(item.value, isVisible);
            }
        })
    }, [selectedItems]);

    return (
        <>
            <ClassificationContainer>
                <div className="classification_sections">
                    <Card bordered={false} style={{ width: 200 }}>
                        <div className="classification_sections-container">
                            <div className="classification_sections-item">
                                <Checkbox
                                    checked={selectAll}
                                    onChange={handleSelectAllChange}
                                >
                                    Show/Hide All
                                </Checkbox>
                            </div>
                            {classification.map((item, index) => (
                                <div key={index} className="classification_sections-item">
                                    <Checkbox
                                        checked={selectedItems.some(selectedItem => selectedItem.value === item.value)}
                                        onChange={e => handleItemChange(e, { value: item.value, label: item.label })}
                                    />
                                    <p>{item.label}</p>
                                </div>
                            ))}
                        </div>
                    </Card>
                </div>
            </ClassificationContainer>
        </>
    );
}